// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toaster[data-v-7775ba7a]{position:fixed!important;top:0!important;right:0!important;width:100%!important;z-index:10000!important}", ""]);
// Exports
module.exports = exports;
